const APP_CONFIG = {
  FRONTEND_VERSION: 44,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
